import { isModernEnterprisePlan } from '../internal/modernSubscription/isModernEnterprisePlan';
import type { Subscription } from '../types';

import { isModernSubscription } from './isModernSubscription';

export function isEnterprisePlan(subscription: Subscription): boolean {
  if (isModernSubscription(subscription)) {
    return isModernEnterprisePlan(subscription);
  }
  return false;
}
